import { createReducer } from "@reduxjs/toolkit";
import { getTicketListConfig, getTicketsList, syncTickers, getUser, updateUser, deleteAccount, logout, completeProfile, signInUser, clearUser, getSubscriptions, deleteTicket, updateTicket } from "../AsyncThunk";

const initialState = {
  ticketListConfig: null,
  userProfile: null,
  user: null,
  loadingAuth: false,
  ticketListConfigFailed: false,
  ticketsList: [],
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(getTicketListConfig.pending, (state, action) => {
      state.ticketListConfigFailed = false;
    })
    .addCase(getTicketListConfig.fulfilled, (state, action) => {
      state.ticketListConfig = action.payload.config;
      state.ticketListConfigVersions = action.payload.versions;
    })
    .addCase(getTicketListConfig.rejected, (state, action) => {
      state.ticketListConfigFailed = true;
    })
    .addCase(syncTickers.pending, (state, action) => {
      state.syncTickersStatus = "pending";
      state.isSyncingTickers = true;
    })
    .addCase(syncTickers.fulfilled, (state, action) => {
      state.isSyncingTickers = false;
    })
    .addCase(syncTickers.rejected, (state, action) => {
      state.isSyncingTickers = false;
      state.syncTickersError = action.payload;
    })
    .addCase(getUser.pending, (state) => {
      state.loadingAuth = true;
    })
    .addCase(getUser.fulfilled, (state, action) => {
      state.loadingAuth = false;
      state.user = action.payload.user;
      state.userProfile = action.payload.userProfile;
      if(action.payload.userProfile) {
      state.isAuthenticated = true;
      }
    })
    .addCase(getUser.rejected, (state) => {
      state.loadingAuth = false;
      state.userProfile = null;
      state.user = null;
      state.isAuthenticated = false;
    })
    .addCase(signInUser.pending, (state) => {
      state.loadingAuth = true;
    })
    .addCase(signInUser.fulfilled, (state, action) => {
      state.loadingAuth = false;
    })
    .addCase(signInUser.rejected, (state, action) => {
      state.loadingAuth = false;
    })
    .addCase(logout.fulfilled, (state) => {
      state.userProfile = null;
      state.user = null;
    })
    .addCase(updateUser.fulfilled, (state, action) => {
      const updatedFields = action.meta.arg;
      if (action.payload.success) {
        state.userProfile = {
          ...state.userProfile,
          ...updatedFields,
        };
      }
    })
    .addCase(deleteAccount.fulfilled, (state, action) => {
      state.userProfile = null;
      state.user = null;
    })
    .addCase(clearUser.fulfilled, (state, action) => {
      state.userProfile = null;
      state.user = null;
    })
    .addCase(completeProfile.fulfilled, (state, action) => {
      const { firstName, lastName } = action.meta.arg;
      state.userProfile = {
        ...state.userProfile,
        first_name: firstName,
        last_name: lastName,
      };
    })
    .addCase(getSubscriptions.pending, (state) => {
      state.loadingSubscriptions = true;
    })
    .addCase(getSubscriptions.fulfilled, (state, action) => {
      state.subscriptions = action.payload;
      state.loadingSubscriptions = false;
    })
    .addCase(getSubscriptions.rejected, (state, action) => {
        state.loadingSubscriptions = false;
        state.subscriptionsError = true;
    })
    .addCase(deleteTicket.fulfilled, (state, action) => {
      if(!action.payload.isLocal) {
        state.ticketsList = state.ticketsList.filter((ticket) => ticket.id !== action.payload.data);
      }
    })
    .addCase(updateTicket.fulfilled, (state, action) => {
      if(!action.payload.isLocal) {
        const ticketIndex = state.ticketsList.findIndex((ticket) => ticket.id === action.payload.data.id);
        if(ticketIndex !== -1) {
          state.ticketsList[ticketIndex] = action.payload.data;
        }
        else {
          state.ticketsList.push(action.payload.data);
        }
      }
    })
    .addCase(getTicketsList.pending, (state) => {
      state.loadingTicketsList = true;
    })
    .addCase(getTicketsList.fulfilled, (state, action) => {
      state.ticketsList = action.payload;
      state.loadingTicketsList = false;
    })
    .addCase(getTicketsList.rejected, (state, action) => {
      state.loadingTicketsList = false;
    })
});
